module.exports = __webpack_public_path__ + "static/media/ETH(ERC20).c0eddfbe.jpeg";